'use strict';

export const ERROR_TITLE = 'Unexpected Error';
export const ERROR_BODY = '<h5>Unfortunately there was an unexpected error</h5>Please try again or contact customer service.';
